module.exports = __webpack_public_path__ + "img/aqt_logo.6c429914.png";